export const arrayToObject = (array, key) =>
  array.reduce((acc, item, index) => {
    acc[item[key] || index] = item;

    return acc;
  }, {});

export const flattenByField = (array, field) =>
  array.reduce(
    (acc, item) =>
      Array.isArray(item[field]) ? acc.concat(item[field]) : acc.concat(item),
    []
  );

export const arrayToArrayOfObjectsByValue = (array, key) =>
  array.reduce((acc, item) => {
    const processKey = item[key] || 'empty';
    acc[processKey] = acc[processKey] ? [...acc[processKey], item] : [item];
    return acc;
  }, []);

export const arrayToObjectByValue = (array, key) =>
  array.reduce((acc, item) => {
    const processKey = item[key] || 'empty';
    acc[processKey] = acc[processKey] ? [...acc[processKey], item] : [item];
    return acc;
  }, {});
